(() => {
    "use strict";
    var e = {
        864: e => {
            e.exports = import("https://cdn.skypack.dev/@vimeo/player")
        }
    }, t = {};

    function n(r) {
        var o = t[r];
        if (void 0 !== o) return o.exports;
        var s = t[r] = {exports: {}};
        return e[r](s, s.exports, n), s.exports
    }

    const r = class {
            errors = ["Element not found", "Element is not an iframe", "Youtube url does not include query parameter - enablejsapi=1 - JS API is disabled"];
            playerStates = {
                [-2]: "NOT_READY",
                [-1]: "UNSTARTED",
                0: "ENDED",
                1: "PLAYING",
                2: "PAUSED",
                3: "BUFFERING",
                5: "CUED"
            };
            currentPlayerStateCode = -2;
            iframe;
            loaded;
            messageListener = null;

            constructor(e) {
                let t = null;
                "string" == typeof e ? (t = document.querySelector(e), null === t && this.throwError(0, e)) : t = e, t instanceof HTMLIFrameElement ? this.iframe = t : this.throwError(1), this.iframe.src.includes("enablejsapi=1") || this.throwError(2, this.iframe.src), this.loaded = new Promise(e => {
                    let t = !1;
                    const n = () => {
                        this.iframe.removeEventListener("load", n), setTimeout(() => {
                            this.iframe.contentWindow?.postMessage('{"event":"listening"}', "*")
                        })
                    };
                    this.iframe.addEventListener("load", n), this.messageListener = r => {
                        if (r.source === this.iframe.contentWindow && r.data) {
                            let o;
                            try {
                                o = JSON.parse(r.data)
                            } catch {
                                return
                            }
                            "onReady" !== o.event || t || (t = !0, this.iframe.removeEventListener("load", n), e(!0)), "number" == typeof o.info?.playerState && this.stateChangeHandler(o.info.playerState), this.messageHandler(o)
                        }
                    }, window.addEventListener("message", this.messageListener), this.iframe.contentWindow?.postMessage('{"event":"listening"}', "*")
                })
            }

            throwError(e, t) {
                throw new Error(this.errors[e] + (t ? `: ${t}` : "."))
            }

            stateChangeHandler(e) {
                this.currentPlayerStateCode = e;
                const t = new CustomEvent("ytstatechange", {detail: this.playerStates[this.currentPlayerStateCode]});
                this.iframe.dispatchEvent(t)
            }

            messageHandler(e) {
                const t = new CustomEvent("ytmessage", {detail: e});
                this.iframe.dispatchEvent(t)
            }

            async command(e, t) {
                await this.loaded, this.iframe.contentWindow?.postMessage(JSON.stringify({
                    event: "command",
                    func: e,
                    args: t || []
                }), "*")
            }

            async play() {
                return this.command("playVideo")
            }

            async pause() {
                return this.command("pauseVideo")
            }

            async stop() {
                return this.command("stopVideo")
            }

            async mute() {
                return this.command("mute")
            }

            async unMute() {
                return this.command("unMute")
            }

            get playerState() {
                return this.playerStates[this.currentPlayerStateCode]
            }
        },
        o = [["requestFullscreen", "exitFullscreen", "fullscreenElement", "fullscreenEnabled", "fullscreenchange", "fullscreenerror"], ["webkitRequestFullscreen", "webkitExitFullscreen", "webkitFullscreenElement", "webkitFullscreenEnabled", "webkitfullscreenchange", "webkitfullscreenerror"], ["webkitRequestFullScreen", "webkitCancelFullScreen", "webkitCurrentFullScreenElement", "webkitCancelFullScreen", "webkitfullscreenchange", "webkitfullscreenerror"], ["mozRequestFullScreen", "mozCancelFullScreen", "mozFullScreenElement", "mozFullScreenEnabled", "mozfullscreenchange", "mozfullscreenerror"], ["msRequestFullscreen", "msExitFullscreen", "msFullscreenElement", "msFullscreenEnabled", "MSFullscreenChange", "MSFullscreenError"]],
        s = (() => {
            if ("undefined" == typeof document) return !1;
            const e = o[0], t = {};
            for (const n of o) {
                const r = n?.[1];
                if (r in document) {
                    for (const [r, o] of n.entries()) t[e[r]] = o;
                    return t
                }
            }
            return !1
        })(), i = {change: s.fullscreenchange, error: s.fullscreenerror};
    let a = {
        request: (e = document.documentElement, t) => new Promise((n, r) => {
            const o = () => {
                a.off("change", o), n()
            };
            a.on("change", o);
            const i = e[s.requestFullscreen](t);
            i instanceof Promise && i.then(o).catch(r)
        }), exit: () => new Promise((e, t) => {
            if (!a.isFullscreen) return void e();
            const n = () => {
                a.off("change", n), e()
            };
            a.on("change", n);
            const r = document[s.exitFullscreen]();
            r instanceof Promise && r.then(n).catch(t)
        }), toggle: (e, t) => a.isFullscreen ? a.exit() : a.request(e, t), onchange(e) {
            a.on("change", e)
        }, onerror(e) {
            a.on("error", e)
        }, on(e, t) {
            const n = i[e];
            n && document.addEventListener(n, t, !1)
        }, off(e, t) {
            const n = i[e];
            n && document.removeEventListener(n, t, !1)
        }, raw: s
    };
    Object.defineProperties(a, {
        isFullscreen: {get: () => Boolean(document[s.fullscreenElement])},
        element: {enumerable: !0, get: () => document[s.fullscreenElement] ?? void 0},
        isEnabled: {enumerable: !0, get: () => Boolean(document[s.fullscreenEnabled])}
    }), s || (a = {isEnabled: !1});
    const c = a;

    function l() {
    }

    const u = e => e;

    function d(e, t) {
        for (const n in t) e[n] = t[n];
        return e
    }

    function m(e) {
        return e()
    }

    function f(e) {
        e.forEach(m)
    }

    function p(e) {
        return "function" == typeof e
    }

    function h(e, t) {
        return e != e ? t == t : e !== t
    }

    function g(e, t, n) {
        e.$$.on_destroy.push(function (e, ...t) {
            if (null == e) return l;
            const n = e.subscribe(...t);
            return n.unsubscribe ? () => n.unsubscribe() : n
        }(t, n))
    }

    function v(e) {
        return e && p(e.destroy) ? e.destroy : l
    }

    let b = () => globalThis.performance.now(), y = e => requestAnimationFrame(e);
    const w = new Set;

    function $(e) {
        w.forEach(t => {
            t.c(e) || (w.delete(t), t.f())
        }), 0 !== w.size && y($)
    }

    function E(e) {
        let t;
        return 0 === w.size && y($), {
            promise: new Promise(n => {
                w.add(t = {c: e, f: n})
            }), abort() {
                w.delete(t)
            }
        }
    }

    function x(e, t) {
        e.appendChild(t)
    }

    function L(e, t, n) {
        e.insertBefore(t, n || null)
    }

    function S(e) {
        e.parentNode.removeChild(e)
    }

    function k(e) {
        return document.createElement(e)
    }

    function C() {
        return document.createTextNode("")
    }

    function M(e, t, n, r) {
        return e.addEventListener(t, n, r), () => e.removeEventListener(t, n, r)
    }

    function A(e, t, n) {
        null == n ? e.removeAttribute(t) : e.getAttribute(t) !== n && e.setAttribute(t, n)
    }

    function F(e, t, n, r) {
        null === n ? e.style.removeProperty(t) : e.style.setProperty(t, n)
    }

    function R(e, t, n) {
        e.classList[n ? "add" : "remove"](t)
    }

    let T, z, P = 0, H = {};

    function q(e, t, n, r, o, s, i, a = 0) {
        const c = 16.666 / r;
        let l = "{\n";
        for (let e = 0; e <= 1; e += c) {
            const r = t + (n - t) * s(e);
            l += 100 * e + `%{${i(r, 1 - r)}}\n`
        }
        const u = l + `100% {${i(n, 1 - n)}}\n}`, d = `_bp_${Math.round(1e9 * Math.random())}_${a}`;
        if (!H[d]) {
            if (!T) {
                const e = k("style");
                document.head.appendChild(e), T = e.sheet
            }
            H[d] = !0, T.insertRule(`@keyframes ${d} ${u}`, T.cssRules.length)
        }
        const m = e.style.animation || "";
        return e.style.animation = `${m ? `${m}, ` : ""}${d} ${r}ms linear ${o}ms 1 both`, P += 1, d
    }

    function I(e, t) {
        e.style.animation = (e.style.animation || "").split(", ").filter(t ? e => e.indexOf(t) < 0 : e => -1 === e.indexOf("_bp")).join(", "), t && !--P && y(() => {
            if (P) return;
            let e = T.cssRules.length;
            for (; e--;) T.deleteRule(e);
            H = {}
        })
    }

    function _(e) {
        z = e
    }

    const N = [], D = [], O = [], V = [], Y = Promise.resolve();
    let W = !1;

    function B(e) {
        O.push(e)
    }

    const X = new Set;
    let U, j = 0;

    function J() {
        const e = z;
        do {
            for (; j < N.length;) {
                const e = N[j];
                j++, _(e), G(e.$$)
            }
            for (_(null), N.length = 0, j = 0; D.length;) D.pop()();
            for (let e = 0; e < O.length; e += 1) {
                const t = O[e];
                X.has(t) || (X.add(t), t())
            }
            O.length = 0
        } while (N.length);
        for (; V.length;) V.pop()();
        W = !1, X.clear(), _(e)
    }

    function G(e) {
        if (null !== e.fragment) {
            e.update(), f(e.before_update);
            const t = e.dirty;
            e.dirty = [-1], e.fragment && e.fragment.p(e.ctx, t), e.after_update.forEach(B)
        }
    }

    function Z() {
        return U || (U = Promise.resolve(), U.then(() => {
            U = null
        })), U
    }

    function K(e, t, n) {
        e.dispatchEvent(function (e, t, n = !1) {
            const r = document.createEvent("CustomEvent");
            return r.initCustomEvent(e, n, !1, t), r
        }(`${t ? "intro" : "outro"}${n}`))
    }

    const Q = new Set;
    let ee;

    function te() {
        ee = {r: 0, c: [], p: ee}
    }

    function ne() {
        ee.r || f(ee.c), ee = ee.p
    }

    function re(e, t) {
        e && e.i && (Q.delete(e), e.i(t))
    }

    function oe(e, t, n, r) {
        if (e && e.o) {
            if (Q.has(e)) return;
            Q.add(e), ee.c.push(() => {
                Q.delete(e), r && (n && e.d(1), r())
            }), e.o(t)
        }
    }

    const se = {duration: 0};

    function ie(e, t, n) {
        let r, o, s = t(e, n), i = !1, a = 0;

        function c() {
            r && I(e, r)
        }

        function d() {
            const {delay: t = 0, duration: n = 300, easing: d = u, tick: m = l, css: f} = s || se;
            f && (r = q(e, 0, 1, n, t, d, f, a++)), m(0, 1);
            const p = b() + t, h = p + n;
            o && o.abort(), i = !0, B(() => K(e, !0, "start")), o = E(t => {
                if (i) {
                    if (t >= h) return m(1, 0), K(e, !0, "end"), c(), i = !1;
                    if (t >= p) {
                        const e = d((t - p) / n);
                        m(e, 1 - e)
                    }
                }
                return i
            })
        }

        let m = !1;
        return {
            start() {
                m || (m = !0, I(e), p(s) ? (s = s(), Z().then(d)) : d())
            }, invalidate() {
                m = !1
            }, end() {
                i && (c(), i = !1)
            }
        }
    }

    function ae(e, t, n) {
        let r, o = t(e, n), s = !0;
        const i = ee;

        function a() {
            const {delay: t = 0, duration: n = 300, easing: a = u, tick: c = l, css: d} = o || se;
            d && (r = q(e, 1, 0, n, t, a, d));
            const m = b() + t, p = m + n;
            B(() => K(e, !1, "start")), E(t => {
                if (s) {
                    if (t >= p) return c(0, 1), K(e, !1, "end"), --i.r || f(i.c), !1;
                    if (t >= m) {
                        const e = a((t - m) / n);
                        c(1 - e, e)
                    }
                }
                return s
            })
        }

        return i.r += 1, p(o) ? Z().then(() => {
            o = o(), a()
        }) : a(), {
            end(t) {
                t && o.tick && o.tick(1, 0), s && (r && I(e, r), s = !1)
            }
        }
    }

    function ce(e) {
        e && e.c()
    }

    function le(e, t, n, r) {
        const {fragment: o, on_mount: s, on_destroy: i, after_update: a} = e.$$;
        o && o.m(t, n), r || B(() => {
            const t = s.map(m).filter(p);
            i ? i.push(...t) : f(t), e.$$.on_mount = []
        }), a.forEach(B)
    }

    function ue(e, t) {
        const n = e.$$;
        null !== n.fragment && (f(n.on_destroy), n.fragment && n.fragment.d(t), n.on_destroy = n.fragment = null, n.ctx = [])
    }

    function de(e, t, n, r, o, s, i, a = [-1]) {
        const c = z;
        _(e);
        const u = e.$$ = {
            fragment: null,
            ctx: null,
            props: s,
            update: l,
            not_equal: o,
            bound: {},
            on_mount: [],
            on_destroy: [],
            on_disconnect: [],
            before_update: [],
            after_update: [],
            context: new Map(t.context || (c ? c.$$.context : [])),
            callbacks: {},
            dirty: a,
            skip_bound: !1,
            root: t.target || c.$$.root
        };
        i && i(u.root);
        let d = !1;
        u.ctx = n ? n(e, t.props || {}, (t, n, ...r) => {
            const s = r.length ? r[0] : n;
            return u.ctx && o(u.ctx[t], u.ctx[t] = s) && (!u.skip_bound && u.bound[t] && u.bound[t](s), d && function (e, t) {
                -1 === e.$$.dirty[0] && (N.push(e), W || (W = !0, Y.then(J)), e.$$.dirty.fill(0)), e.$$.dirty[t / 31 | 0] |= 1 << t % 31
            }(e, t)), n
        }) : [], u.update(), d = !0, f(u.before_update), u.fragment = !!r && r(u.ctx), t.target && (u.fragment && u.fragment.c(), le(e, t.target, t.anchor, t.customElement), J()), _(c)
    }

    class me {
        $destroy() {
            ue(this, 1), this.$destroy = l
        }

        $on(e, t) {
            const n = this.$$.callbacks[e] || (this.$$.callbacks[e] = []);
            return n.push(t), () => {
                const e = n.indexOf(t);
                -1 !== e && n.splice(e, 1)
            }
        }

        $set(e) {
            var t;
            this.$$set && (t = e, 0 !== Object.keys(t).length) && (this.$$.skip_bound = !0, this.$$set(e), this.$$.skip_bound = !1)
        }
    }

    function fe(e) {
        const t = e - 1;
        return t * t * t + 1
    }

    function pe(e, {delay: t = 0, duration: n = 400, easing: r = fe, x: o = 0, y: s = 0, opacity: i = 0} = {}) {
        const a = getComputedStyle(e), c = +a.opacity, l = "none" === a.transform ? "" : a.transform, u = c * (1 - i);
        return {
            delay: t,
            duration: n,
            easing: r,
            css: (e, t) => `\n\t\t\ttransform: ${l} translate(${(1 - e) * o}px, ${(1 - e) * s}px);\n\t\t\topacity: ${c - u * t}`
        }
    }

    const he = [];

    function ge(e, t = l) {
        let n;
        const r = new Set;

        function o(t) {
            if (h(e, t) && (e = t, n)) {
                const t = !he.length;
                for (const t of r) t[1](), he.push(t, e);
                if (t) {
                    for (let e = 0; e < he.length; e += 2) he[e][0](he[e + 1]);
                    he.length = 0
                }
            }
        }

        return {
            set: o, update: function (t) {
                o(t(e))
            }, subscribe: function (s, i = l) {
                const a = [s, i];
                return r.add(a), 1 === r.size && (n = t(o) || l), s(e), () => {
                    r.delete(a), 0 === r.size && (n(), n = null)
                }
            }
        }
    }

    function ve(e, t) {
        if (e === t || e != e) return () => e;
        const n = typeof e;
        if (Array.isArray(e)) {
            const n = t.map((t, n) => ve(e[n], t));
            return e => n.map(t => t(e))
        }
        if ("number" === n) {
            const n = t - e;
            return t => e + t * n
        }
    }

    function be(e, t = {}) {
        const n = ge(e);
        let r, o = e;

        function s(s, i) {
            if (null == e) return n.set(e = s), Promise.resolve();
            o = s;
            let a = r, c = !1, {delay: l = 0, duration: m = 400, easing: f = u, interpolate: p = ve} = d(d({}, t), i);
            if (0 === m) return a && (a.abort(), a = null), n.set(e = o), Promise.resolve();
            const h = b() + l;
            let g;
            return r = E(t => {
                if (t < h) return !0;
                c || (g = p(e, s), "function" == typeof m && (m = m(e, s)), c = !0), a && (a.abort(), a = null);
                const r = t - h;
                return r > m ? (n.set(e = s), !1) : (n.set(e = g(f(r / m))), !0)
            }), r.promise
        }

        return {set: s, update: (t, n) => s(t(o, e), n), subscribe: n.subscribe}
    }

    const ye = ge(0), we = globalThis.matchMedia?.("(prefers-reduced-motion: reduce)").matches,
        $e = e => ({easing: fe, duration: we ? 0 : e}), Ee = e => !e.thumb || `url(${e.thumb})`, xe = (e, t) => {
            if (t) {
                "string" == typeof t && (t = JSON.parse(t));
                for (const n in t) e.setAttribute(n, t[n])
            }
        };

    function Le(e) {
        let t, n, r;
        return {
            c() {
                t = k("div"), t.innerHTML = '<span class="bp-bar"></span><span class="bp-o"></span>', A(t, "class", "bp-load"), F(t, "background-image", Ee(e[0]))
            }, m(e, n) {
                L(e, t, n), r = !0
            }, p(e, n) {
                1 & n && F(t, "background-image", Ee(e[0]))
            }, i(e) {
                r || (n && n.end(1), r = !0)
            }, o(e) {
                e && (n = ae(t, pe, {duration: 480})), r = !1
            }, d(e) {
                e && S(t), e && n && n.end()
            }
        }
    }

    function Se(e) {
        let t, n;
        return {
            c() {
                t = k("div"), A(t, "class", "bp-load"), F(t, "background-image", Ee(e[0]))
            }, m(e, n) {
                L(e, t, n)
            }, p(e, n) {
                1 & n && F(t, "background-image", Ee(e[0]))
            }, i(e) {
                n || B(() => {
                    n = ie(t, pe, {duration: 480}), n.start()
                })
            }, o: l, d(e) {
                e && S(t)
            }
        }
    }

    function ke(e) {
        let t, n, r = !e[1] && Le(e), o = e[2] && Se(e);
        return {
            c() {
                r && r.c(), t = C(), o && o.c(), n = C()
            }, m(e, s) {
                r && r.m(e, s), L(e, t, s), o && o.m(e, s), L(e, n, s)
            }, p(e, [s]) {
                e[1] ? r && (te(), oe(r, 1, 1, () => {
                    r = null
                }), ne()) : r ? (r.p(e, s), 2 & s && re(r, 1)) : (r = Le(e), r.c(), re(r, 1), r.m(t.parentNode, t)), e[2] ? o ? (o.p(e, s), 4 & s && re(o, 1)) : (o = Se(e), o.c(), re(o, 1), o.m(n.parentNode, n)) : o && (o.d(1), o = null)
            }, i(e) {
                re(r), re(o)
            }, o(e) {
                oe(r)
            }, d(e) {
                r && r.d(e), e && S(t), o && o.d(e), e && S(n)
            }
        }
    }

    function Ce(e, t, n) {
        let r;
        g(e, ye, e => n(2, r = e));
        let {activeItem: o} = t, {loaded: s} = t;
        return e.$$set = e => {
            "activeItem" in e && n(0, o = e.activeItem), "loaded" in e && n(1, s = e.loaded)
        }, [o, s, r]
    }

    class Me extends me {
        constructor(e) {
            super(), de(this, e, Ce, ke, h, {activeItem: 0, loaded: 1})
        }
    }

    function Ae(e) {
        let t, n, r, o, s, i;
        return {
            c() {
                t = k("img"), A(t, "sizes", n = e[8].sizes || `${e[1]}px`), A(t, "alt", e[7].alt)
            }, m(n, r) {
                L(n, t, r), o = !0, s || (i = [v(e[21].call(null, t)), M(t, "error", e[27])], s = !0)
            }, p(e, r) {
                (!o || 2 & r[0] && n !== (n = e[8].sizes || `${e[1]}px`)) && A(t, "sizes", n)
            }, i(e) {
                o || (r && r.end(1), o = !0)
            }, o(e) {
                r = ae(t, pe, {}), o = !1
            }, d(e) {
                e && S(t), e && r && r.end(), s = !1, f(i)
            }
        }
    }

    function Fe(e) {
        let t, n;
        return t = new Me({props: {activeItem: e[7], loaded: e[2]}}), {
            c() {
                ce(t.$$.fragment)
            }, m(e, r) {
                le(t, e, r), n = !0
            }, p(e, n) {
                const r = {};
                4 & n[0] && (r.loaded = e[2]), t.$set(r)
            }, i(e) {
                n || (re(t.$$.fragment, e), n = !0)
            }, o(e) {
                oe(t.$$.fragment, e), n = !1
            }, d(e) {
                ue(t, e)
            }
        }
    }

    function Re(e) {
        let t, n, r, o, s, i, a = `translate3d(${e[0][0] / -2 + e[6][0]}px, ${e[0][1] / -2 + e[6][1]}px, 0)`,
            c = e[2] && Ae(e), l = e[3] && Fe(e);
        return {
            c() {
                t = k("div"), n = k("div"), c && c.c(), r = C(), l && l.c(), A(n, "class", "bp-img"), F(n, "width", e[0][0] + "px"), F(n, "height", e[0][1] + "px"), R(n, "bp-drag", e[4]), R(n, "bp-canzoom", e[11] > 1 && e[0][0] < e[12]), F(n, "background-image", Ee(e[7])), F(n, "transform", a), A(t, "class", "bp-img-wrap"), R(t, "bp-close", e[5])
            }, m(a, u) {
                L(a, t, u), x(t, n), c && c.m(n, null), x(n, r), l && l.m(n, null), o = !0, s || (i = [v(e[20].call(null, n)), M(t, "wheel", e[15]), M(t, "pointerdown", e[16]), M(t, "pointermove", e[17]), M(t, "pointerup", e[19]), M(t, "pointercancel", e[18])], s = !0)
            }, p(e, s) {
                e[2] ? c ? (c.p(e, s), 4 & s[0] && re(c, 1)) : (c = Ae(e), c.c(), re(c, 1), c.m(n, r)) : c && (te(), oe(c, 1, 1, () => {
                    c = null
                }), ne()), e[3] ? l ? (l.p(e, s), 8 & s[0] && re(l, 1)) : (l = Fe(e), l.c(), re(l, 1), l.m(n, null)) : l && (te(), oe(l, 1, 1, () => {
                    l = null
                }), ne()), (!o || 1 & s[0]) && F(n, "width", e[0][0] + "px"), (!o || 1 & s[0]) && F(n, "height", e[0][1] + "px"), (!o || 16 & s[0]) && R(n, "bp-drag", e[4]), (!o || 6145 & s[0]) && R(n, "bp-canzoom", e[11] > 1 && e[0][0] < e[12]), 65 & s[0] && a !== (a = `translate3d(${e[0][0] / -2 + e[6][0]}px, ${e[0][1] / -2 + e[6][1]}px, 0)`) && F(n, "transform", a), (!o || 32 & s[0]) && R(t, "bp-close", e[5])
            }, i(e) {
                o || (re(c), re(l), o = !0)
            }, o(e) {
                oe(c), oe(l), o = !1
            }, d(e) {
                e && S(t), c && c.d(), l && l.d(), s = !1, f(i)
            }
        }
    }

    function Te(e, t, n) {
        let r, o, s, i;
        g(e, ye, e => n(26, s = e));
        let {props: a} = t, {smallScreen: c} = t, {
            activeItem: l,
            opts: u,
            prev: d,
            next: m,
            zoomed: f,
            container: p
        } = a;
        g(e, f, e => n(25, r = e));
        let h, v, b, y, w, $, E, x, L, S, k, C = l.maxZoom || u.maxZoom || 10, M = a.calculateDimensions(l), A = M[0],
            F = 0;
        const R = +l.width, T = [], z = new Map, P = be(M, $e(400));
        g(e, P, e => n(0, i = e));
        const H = be([0, 0], $e(400));
        g(e, H, e => n(6, o = e));
        const q = ([e, t], r = i) => {
            const o = (r[0] - p.w) / 2, s = (r[1] - p.h) / 2;
            return o < 0 ? e = 0 : e > o ? c ? (e = w ? o + (e - o) / 10 : o) > o + 20 && n(4, w = d()) : e = o : e < -o && (c ? (e = w ? -o - (-o - e) / 10 : -o) < -o - 20 && n(4, w = m()) : e = -o), s < 0 ? t = 0 : t > s ? t = s : t < -s && (t = -s), [e, t]
        };

        function I(e = C, t) {
            if (s) return;
            const r = M[0] * C;
            let a = i[0] + i[0] * e, c = i[1] + i[1] * e;
            if (e > 0) a > r && (a = r, c = M[1] * C), a > R && (a = R, c = +l.height); else if (a < M[0]) return P.set(M), H.set([0, 0]);
            let {x: u, y: d, width: m, height: f} = y.getBoundingClientRect();
            const p = t ? t.clientX - u - m / 2 : 0, h = t ? t.clientY - d - f / 2 : 0;
            u = a / m * -p + p, d = c / f * -h + h;
            const g = [a, c];
            P.set(g).then(() => {
                n(1, A = Math.round(Math.max(A, a)))
            }), H.set(q([o[0] + u, o[1] + d], g))
        }

        Object.defineProperty(l, "zoom", {configurable: !0, get: () => r, set: e => I(e ? C : -C)});
        const _ = e => z.delete(e.pointerId);
        return e.$$set = e => {
            "smallScreen" in e && n(23, c = e.smallScreen)
        }, e.$$.update = () => {
            if (16777217 & e.$$.dirty[0] && f.set(i[0] - 10 > M[0]), 117440512 & e.$$.dirty[0] && s && r && !u.intro) {
                const e = $e(480);
                H.set([0, 0], e), P.set(M, e), n(5, k = !0)
            }
        }, [i, A, h, v, w, k, o, l, u, f, p, C, R, P, H, e => {
            u.inline && !r || (e.preventDefault(), I(e.deltaY / -300, e))
        }, e => {
            2 !== e.button && (e.preventDefault(), n(4, w = !0), z.set(e.pointerId, e), E = e.clientX, x = e.clientY, L = o[0], S = o[1])
        }, e => {
            if (z.size > 1) return n(4, w = !1), u.noPinch?.(p.el) || (e => {
                const [t, n] = z.set(e.pointerId, e).values(), r = t.clientX - n.clientX, o = t.clientY - n.clientY,
                    s = Math.hypot(r, o);
                b = b || {
                    clientX: (t.clientX + n.clientX) / 2,
                    clientY: (t.clientY + n.clientY) / 2
                }, I(((F || s) - s) / -35, b), F = s
            })(e);
            if (!w) return;
            let t = e.clientX, o = e.clientY;
            $ = T.push({
                x: t,
                y: o
            }) > 2, t -= E, o -= x, r || (o < -90 && n(4, w = !u.noClose && a.close()), Math.abs(o) < 30 && (t > 40 && n(4, w = d()), t < -40 && n(4, w = m()))), r && $ && !s && H.set(q([L + t, S + o]), {duration: 0})
        }, _, function (e) {
            if (_(e), b && (n(4, w = F = 0), b = z.size ? b : null), w) {
                if (n(4, w = !1), e.target === this && !u.noClose) return a.close();
                if ($) {
                    const [e, t, n] = T.slice(-3), r = t.x - n.x, s = t.y - n.y;
                    Math.hypot(r, s) > 5 && H.set(q([o[0] - 5 * (e.x - n.x), o[1] - 5 * (e.y - n.y)]))
                } else u.onImageClick?.(p.el, l) || I(r ? -C : C, e);
                $ = !1, T.length = 0
            }
        }, e => {
            y = e, a.setResizeFunc(() => {
                n(24, M = a.calculateDimensions(l)), !u.inline && c || (P.set(M), H.set([0, 0]))
            }), a.loadImage(l).then(() => {
                n(2, h = !0), a.preloadNext()
            }), setTimeout(() => {
                n(3, v = !h)
            }, 250)
        }, e => {
            xe(e, l.attr), e.srcset = l.img
        }, a, c, M, r, s, e => u.onError?.(p, l, e)]
    }

    class ze extends me {
        constructor(e) {
            super(), de(this, e, Te, Re, h, {props: 22, smallScreen: 23}, null, [-1, -1])
        }
    }

    function Pe(e) {
        let t, n, r, o, s, i;
        return r = new Me({props: {activeItem: e[2], loaded: e[0]}}), {
            c() {
                t = k("div"), n = k("iframe"), ce(r.$$.fragment), A(n, "allow", "autoplay; fullscreen"), A(n, "title", e[2].title), A(t, "class", "bp-if"), F(t, "width", e[1][0] + "px"), F(t, "height", e[1][1] + "px")
            }, m(a, c) {
                L(a, t, c), x(t, n), le(r, t, null), o = !0, s || (i = [v(e[3].call(null, n)), M(n, "load", e[5])], s = !0)
            }, p(e, [n]) {
                const s = {};
                1 & n && (s.loaded = e[0]), r.$set(s), (!o || 2 & n) && F(t, "width", e[1][0] + "px"), (!o || 2 & n) && F(t, "height", e[1][1] + "px")
            }, i(e) {
                o || (re(r.$$.fragment, e), o = !0)
            }, o(e) {
                oe(r.$$.fragment, e), o = !1
            }, d(e) {
                e && S(t), ue(r), s = !1, f(i)
            }
        }
    }

    function He(e, t, n) {
        let r, o, {props: s} = t;
        const {activeItem: i} = s, a = () => n(1, o = s.calculateDimensions(i));
        return a(), s.setResizeFunc(a), [r, o, i, e => {
            xe(e, i.attr), e.src = i.iframe
        }, s, () => n(0, r = !0)]
    }

    class qe extends me {
        constructor(e) {
            super(), de(this, e, He, Pe, h, {props: 4})
        }
    }

    function Ie(e) {
        let t, n, r, o, s;
        return n = new Me({props: {activeItem: e[2], loaded: e[0]}}), {
            c() {
                t = k("div"), ce(n.$$.fragment), A(t, "class", "bp-vid"), F(t, "width", e[1][0] + "px"), F(t, "height", e[1][1] + "px"), F(t, "background-image", Ee(e[2]))
            }, m(i, a) {
                L(i, t, a), le(n, t, null), r = !0, o || (s = v(e[3].call(null, t)), o = !0)
            }, p(e, [o]) {
                const s = {};
                1 & o && (s.loaded = e[0]), n.$set(s), (!r || 2 & o) && F(t, "width", e[1][0] + "px"), (!r || 2 & o) && F(t, "height", e[1][1] + "px")
            }, i(e) {
                r || (re(n.$$.fragment, e), r = !0)
            }, o(e) {
                oe(n.$$.fragment, e), r = !1
            }, d(e) {
                e && S(t), ue(n), o = !1, s()
            }
        }
    }

    function _e(e, t, n) {
        let r, o, {props: s} = t;
        const {activeItem: i, opts: a, container: c} = s, l = () => n(1, o = s.calculateDimensions(i));
        return l(), s.setResizeFunc(l), [r, o, i, e => {
            let t;
            const o = (e, n) => {
                Array.isArray(n) || (n = JSON.parse(n));
                for (const r of n) {
                    t || (t = document.createElement(r.type?.includes("audio") ? "audio" : "video"), xe(t, {
                        controls: !0,
                        autoplay: !0,
                        playsinline: !0,
                        tabindex: "0"
                    }), xe(t, i.attr));
                    const n = document.createElement(e);
                    xe(n, r), "source" == e && (n.onError = e => a.onError?.(c, i, e)), t.append(n)
                }
            };
            o("source", i.sources), o("track", i.tracks || []), t.oncanplay = () => n(0, r = !0), e.append(t)
        }, s]
    }

    class Ne extends me {
        constructor(e) {
            super(), de(this, e, _e, Ie, h, {props: 4})
        }
    }

    function De(e) {
        let t, n, r, o, s, i, a, c, u, d = e[6].i, m = Xe(e), p = e[0].length > 1 && Ue(e);
        return {
            c() {
                t = k("div"), n = k("div"), m.c(), o = k("div"), s = k("button"), p && p.c(), A(s, "class", "bp-x"), A(s, "title", "Close"), A(s, "aria-label", "Close"), A(o, "class", "bp-controls"), A(t, "class", "bp-wrap"), R(t, "bp-zoomed", e[10]), R(t, "bp-inline", e[8]), R(t, "bp-small", e[7]), R(t, "bp-noclose", e[5].noClose)
            }, m(r, i) {
                L(r, t, i), x(t, n), m.m(t, null), x(t, o), x(o, s), p && p.m(o, null), a = !0, c || (u = [M(s, "click", e[1]), v(e[14].call(null, t))], c = !0)
            }, p(e, n) {
                64 & n[0] && h(d, d = e[6].i) ? (te(), oe(m, 1, 1, l), ne(), m = Xe(e), m.c(), re(m, 1), m.m(t, o)) : m.p(e, n), e[0].length > 1 ? p ? p.p(e, n) : (p = Ue(e), p.c(), p.m(o, null)) : p && (p.d(1), p = null), (!a || 1024 & n[0]) && R(t, "bp-zoomed", e[10]), (!a || 256 & n[0]) && R(t, "bp-inline", e[8]), (!a || 128 & n[0]) && R(t, "bp-small", e[7]), (!a || 32 & n[0]) && R(t, "bp-noclose", e[5].noClose)
            }, i(e) {
                a || (r && r.end(1), re(m), i && i.end(1), a = !0)
            }, o(e) {
                e && (r = ae(n, pe, {duration: 480})), oe(m), e && (i = ae(o, pe, {})), a = !1
            }, d(e) {
                e && S(t), e && r && r.end(), m.d(e), p && p.d(), e && i && i.end(), c = !1, f(u)
            }
        }
    }

    function Oe(e) {
        let t, n = (e[6].html ?? e[6].element.outerHTML) + "";
        return {
            c() {
                t = k("div"), A(t, "class", "bp-html")
            }, m(e, r) {
                L(e, t, r), t.innerHTML = n
            }, p(e, r) {
                64 & r[0] && n !== (n = (e[6].html ?? e[6].element.outerHTML) + "") && (t.innerHTML = n)
            }, i: l, o: l, d(e) {
                e && S(t)
            }
        }
    }

    function Ve(e) {
        let t, n;
        return t = new qe({props: {props: e[13]()}}), {
            c() {
                ce(t.$$.fragment)
            }, m(e, r) {
                le(t, e, r), n = !0
            }, p: l, i(e) {
                n || (re(t.$$.fragment, e), n = !0)
            }, o(e) {
                oe(t.$$.fragment, e), n = !1
            }, d(e) {
                ue(t, e)
            }
        }
    }

    function Ye(e) {
        let t, n;
        return t = new Ne({props: {props: e[13]()}}), {
            c() {
                ce(t.$$.fragment)
            }, m(e, r) {
                le(t, e, r), n = !0
            }, p: l, i(e) {
                n || (re(t.$$.fragment, e), n = !0)
            }, o(e) {
                oe(t.$$.fragment, e), n = !1
            }, d(e) {
                ue(t, e)
            }
        }
    }

    function We(e) {
        let t, n;
        return t = new ze({props: {props: e[13](), smallScreen: e[7]}}), {
            c() {
                ce(t.$$.fragment)
            }, m(e, r) {
                le(t, e, r), n = !0
            }, p(e, n) {
                const r = {};
                128 & n[0] && (r.smallScreen = e[7]), t.$set(r)
            }, i(e) {
                n || (re(t.$$.fragment, e), n = !0)
            }, o(e) {
                oe(t.$$.fragment, e), n = !1
            }, d(e) {
                ue(t, e)
            }
        }
    }

    function Be(e) {
        let t, n, r, o = e[6].caption + "";
        return {
            c() {
                t = k("div"), A(t, "class", "bp-cap")
            }, m(e, n) {
                L(e, t, n), t.innerHTML = o, r = !0
            }, p(e, n) {
                (!r || 64 & n[0]) && o !== (o = e[6].caption + "") && (t.innerHTML = o)
            }, i(e) {
                r || (n && n.end(1), r = !0)
            }, o(e) {
                n = ae(t, pe, {duration: 200}), r = !1
            }, d(e) {
                e && S(t), e && n && n.end()
            }
        }
    }

    function Xe(e) {
        let t, n, r, o, s, i, a, c, l;
        const u = [We, Ye, Ve, Oe], d = [];

        function m(e, t) {
            return e[6].img ? 0 : e[6].sources ? 1 : e[6].iframe ? 2 : 3
        }

        n = m(e), r = d[n] = u[n](e);
        let p = e[6].caption && Be(e);
        return {
            c() {
                t = k("div"), r.c(), p && p.c(), i = C(), A(t, "class", "bp-inner")
            }, m(r, o) {
                L(r, t, o), d[n].m(t, null), p && p.m(r, o), L(r, i, o), a = !0, c || (l = [M(t, "pointerdown", e[20]), M(t, "pointerup", e[21])], c = !0)
            }, p(e, o) {
                let s = n;
                n = m(e), n === s ? d[n].p(e, o) : (te(), oe(d[s], 1, 1, () => {
                    d[s] = null
                }), ne(), r = d[n], r ? r.p(e, o) : (r = d[n] = u[n](e), r.c()), re(r, 1), r.m(t, null)), e[6].caption ? p ? (p.p(e, o), 64 & o[0] && re(p, 1)) : (p = Be(e), p.c(), re(p, 1), p.m(i.parentNode, i)) : p && (te(), oe(p, 1, 1, () => {
                    p = null
                }), ne())
            }, i(n) {
                a || (re(r), B(() => {
                    s && s.end(1), o = ie(t, e[12], !0), o.start()
                }), re(p), a = !0)
            }, o(n) {
                oe(r), o && o.invalidate(), s = ae(t, e[12], !1), oe(p), a = !1
            }, d(e) {
                e && S(t), d[n].d(), e && s && s.end(), p && p.d(e), e && S(i), c = !1, f(l)
            }
        }
    }

    function Ue(e) {
        let t, n, r, o, s, i = `${e[4] + 1} / ${e[0].length}`;
        return {
            c() {
                t = k("div"), n = k("button"), r = k("button"), A(t, "class", "bp-count"), A(n, "class", "bp-prev"), A(n, "title", "Previous"), A(n, "aria-label", "Previous"), A(r, "class", "bp-next"), A(r, "title", "Next"), A(r, "aria-label", "Next")
            }, m(a, c) {
                L(a, t, c), t.innerHTML = i, L(a, n, c), L(a, r, c), o || (s = [M(n, "click", e[2]), M(r, "click", e[3])], o = !0)
            }, p(e, n) {
                17 & n[0] && i !== (i = `${e[4] + 1} / ${e[0].length}`) && (t.innerHTML = i)
            }, d(e) {
                e && S(t), e && S(n), e && S(r), o = !1, f(s)
            }
        }
    }

    function je(e) {
        let t, n, r = e[0] && De(e);
        return {
            c() {
                r && r.c(), t = C()
            }, m(e, o) {
                r && r.m(e, o), L(e, t, o), n = !0
            }, p(e, n) {
                e[0] ? r ? (r.p(e, n), 1 & n[0] && re(r, 1)) : (r = De(e), r.c(), re(r, 1), r.m(t.parentNode, t)) : r && (te(), oe(r, 1, 1, () => {
                    r = null
                }), ne())
            }, i(e) {
                n || (re(r), n = !0)
            }, o(e) {
                oe(r), n = !1
            }, d(e) {
                r && r.d(e), e && S(t)
            }
        }
    }

    function Je(e, t, n) {
        let r, {items: o} = t, {target: s} = t;
        const i = document.documentElement;
        let a, c, l, u, d, m, f, p, h;
        const v = () => !h.img && !h.sources && !h.iframe;
        let b;
        const y = e => b = e, w = {}, $ = ge(0);
        g(e, $, e => n(10, r = e));
        const E = () => {
            c.onClose?.(w.el, h), ye.set(!0), n(0, o = null), u?.focus({preventScroll: !0})
        }, x = () => S(a - 1), L = () => S(a + 1), S = e => {
            f = e - a, n(4, a = k(e))
        }, k = e => (e + o.length) % o.length, C = e => {
            const {key: t, shiftKey: n} = e;
            if ("Escape" === t) !c.noClose && E(); else if ("ArrowRight" === t) L(); else if ("ArrowLeft" === t) x(); else if ("Tab" === t) {
                const {activeElement: t} = document;
                if (n || !t.controls) {
                    e.preventDefault();
                    const {focusWrap: r = w.el} = c, o = [...r.querySelectorAll("*")].filter(e => e.tabIndex >= 0);
                    let s = o.indexOf(t);
                    s += o.length + (n ? -1 : 1), o[s % o.length].focus()
                }
            }
        }, M = ({width: e = 1920, height: t = 1080}) => {
            const {scale: n = .99} = c, r = Math.min(1, w.w / e * n, w.h / t * n);
            return [Math.round(e * r), Math.round(t * r)]
        }, A = () => {
            if (o) {
                const e = o[k(a + 1)], t = o[k(a - 1)];
                !e.preload && F(e), !t.preload && F(t)
            }
        }, F = e => {
            if (e.img) {
                const t = document.createElement("img");
                return t.sizes = c.sizes || `${M(e)[0]}px`, t.srcset = e.img, e.preload = !0, t.decode().catch(e => {
                })
            }
        };
        return e.$$set = e => {
            "items" in e && n(0, o = e.items), "target" in e && n(15, s = e.target)
        }, e.$$.update = () => {
            786545 & e.$$.dirty[0] && o && (n(6, h = o[a]), l && c.onUpdate?.(w.el, h))
        }, [o, E, x, L, a, c, h, d, m, p, r, $, (e, t) => l && o ? pe(e, {
            x: (f > 0 ? 20 : -20) * (t ? 1 : -1),
            duration: 250
        }) : (n(18, l = t), c.intro ? pe(e, {y: t ? 10 : -10}) : (e => {
            let t;
            if (v()) {
                const n = e.firstChild.firstChild;
                t = [n.clientWidth, n.clientHeight]
            } else t = M(h);
            const n = (h.element || u).getBoundingClientRect(), r = n.left - (w.w - n.width) / 2,
                o = n.top - (w.h - n.height) / 2, s = n.width / t[0], i = n.height / t[1];
            return {
                duration: 480,
                easing: fe,
                css: (e, t) => `transform:translate3d(${r * t}px, ${o * t}px, 0) scale3d(${s + e * (1 - s)}, ${i + e * (1 - i)}, 1)`
            }
        })(e)), () => ({
            activeItem: h,
            calculateDimensions: M,
            loadImage: F,
            preloadNext: A,
            opts: c,
            prev: x,
            next: L,
            close: E,
            setResizeFunc: y,
            zoomed: $,
            container: w
        }), e => {
            let t;
            n(19, w.el = e, w), c.onOpen?.(w.el, h), m || globalThis.addEventListener("keydown", C);
            const r = new ResizeObserver(e => {
                t && (n(19, w.w = e[0].contentRect.width, w), n(19, w.h = e[0].contentRect.height, w), n(7, d = w.w < 769), v() || b?.(), c.onResize?.(w.el, h)), t = !0
            });
            return r.observe(e), {
                destroy() {
                    r.disconnect(), globalThis.removeEventListener("keydown", C), ye.set(!1), i.classList.remove("bp-lock"), c.onClosed?.()
                }
            }
        }, s, e => {
            n(5, c = e), n(8, m = c.inline), !m && i.scrollHeight > i.clientHeight && i.classList.add("bp-lock"), u = document.activeElement, n(19, w.w = s.offsetWidth, w), n(19, w.h = s === document.body ? globalThis.innerHeight : s.clientHeight, w), n(7, d = w.w < 769), n(4, a = c.position || 0), n(0, o = []);
            for (let e = 0; e < (c.items.length || 1); e++) {
                let t = c.items[e] || c.items;
                "dataset" in t ? o.push({
                    element: t,
                    i: e, ...t.dataset
                }) : (t.i = e, o.push(t), t = t.element), c.el && c.el === t && n(4, a = e)
            }
        }, S, l, w, e => n(9, p = e.target), function (e) {
            2 !== e.button && e.target === this && p === this && !c.noClose && E()
        }]
    }

    const Ge = document, Ze = Ge.body, Ke = Ge.getElementById.bind(Ge), Qe = Ge.querySelector.bind(Ge),
        et = Ge.querySelectorAll.bind(Ge);
    let tt;
    window.ARVEvimeo = new WeakMap, window.ARVEyoutube = new WeakMap;
    const nt = (rt = {target: Ze}, new class extends me {
        constructor(e) {
            super(), de(this, e, Je, je, h, {
                items: 0,
                target: 15,
                open: 16,
                close: 1,
                prev: 2,
                next: 3,
                setPosition: 17
            }, null, [-1, -1])
        }

        get items() {
            return this.$$.ctx[0]
        }

        get target() {
            return this.$$.ctx[15]
        }

        get open() {
            return this.$$.ctx[16]
        }

        get close() {
            return this.$$.ctx[1]
        }

        get prev() {
            return this.$$.ctx[2]
        }

        get next() {
            return this.$$.ctx[3]
        }

        get setPosition() {
            return this.$$.ctx[17]
        }
    }({...rt, props: rt}));
    var rt;

    function ot(e) {
        const t = getComputedStyle(e).transitionDuration;
        if (t.endsWith("s")) return 1e3 * parseFloat(t);
        if (t.endsWith("ms")) return parseFloat(t);
        throw new Error(`Unsupported unit: ${t}`)
    }

    function st(e) {
        return e.dataset.arve ? Ke(e.dataset.arve) : null
    }

    function it(e) {
        pt(e);
        const t = st(e);
        t && t.classList.add("arve--playing")
    }

    function at(e) {
        const t = st(e);
        t && t.classList.remove("arve--playing")
    }

    function ct(e) {
        const t = st(e);
        if (t) {
            if (t.classList.remove("arve--playing", "arve--sticky"), !t.dataset.mode || !e.dataset.arve) throw "Mode data attr needs to be set";
            !function (e) {
                if ("resetAfterPlayed" in e.dataset) {
                    if (e.classList.remove("arve--last-active", "arve--activated", "arve--playing", "arve--loaded"), e.matches(".arve--card")) {
                        const t = e.querySelector(".arve-inner");
                        if (!t) throw Error(".arve-inner not found");
                        t.setAttribute("role", "button"), t.setAttribute("type", "button")
                    }
                    switch (e.dataset.mode) {
                        case"lazyload":
                            const t = e.querySelector("iframe[data-arve]");
                            t && t.remove(), async function (e) {
                                ("grow" in e.dataset || e.matches(".arve--card")) && (e.classList.add("arve--animating"), "grow" in e.dataset && (e.classList.remove("arve--expanded", "alignfull"), e.dataset.alignClass && e.classList.add(e.dataset.alignClass)), await ut(ot(e)), e.classList.remove("arve--animating"))
                            }(e);
                            break;
                        case"link-lightbox":
                        case"lightbox":
                            Qe(".bp-wrap") && nt.close()
                    }
                }
            }(t)
        }
    }

    function lt(e) {
        "enabled-exit" === e.dataset.fullscreen && c.isEnabled && c.exit(), window.history.pushState("", Ge.title, window.location.pathname + window.location.search), Ze.classList.remove("arve-overflow-hidden"), e.classList.remove("arve--playing", "arve--last-active")
    }

    function ut(e) {
        return new Promise(t => {
            setTimeout(t, e)
        })
    }

    async function dt(e, t) {
        switch (e.dataset.provider) {
            case"youtube":
                if (!window.ARVEyoutube.has(t)) {
                    const e = new r(t);
                    t.addEventListener("ytstatechange", mt), window.ARVEyoutube.set(t, e)
                }
                await window.ARVEyoutube.get(t).play();
                break;
            case"vimeo":
                if (!window.ARVEvimeo.has(t)) {
                    if (!tt) {
                        const {default: e} = await Promise.resolve().then(n.bind(n, 864));
                        tt = e
                    }
                    const e = new tt(t);
                    e.on("play", () => {
                        it(t)
                    }), e.on("pause", () => {
                        at(t)
                    }), e.on("ended", () => {
                        ct(t)
                    }), window.ARVEvimeo.set(t, e)
                }
                window.ARVEvimeo.get(t).play()
        }
    }

    function mt(e) {
        const t = e.currentTarget;
        switch (e.detail) {
            case"ENDED":
                ct(t);
                break;
            case"PLAYING":
                it(t);
                break;
            case"PAUSED":
                at(t)
        }
    }

    function ft(e, t) {
        Ze.classList.add("arve-overflow-hidden"), "disabled" !== e.dataset.fullscreen && c.isEnabled && c.request(), e.querySelector("video") ? nt.open({
            el: t,
            items: t,
            onClose: () => {
                lt(e)
            }
        }) : nt.open({
            el: t, items: t, onOpen: t => {
                const n = t.querySelector("iframe");
                n && dt(e, n)
            }, onClose: () => {
                lt(e)
            }
        }), window.history.pushState("", Ge.title, window.location.pathname + window.location.search + "#" + e.id)
    }

    function pt(e) {
        et("video, audio").forEach(t => {
            if (t === e) return;
            t.pause();
            const n = st(t);
            n && n.classList.remove("arve--playing")
        }), et("iframe[data-arve]").forEach(async t => {
            if (t === e) return;
            if (!t.dataset.arve) throw "iframe must have data-arve set";
            window.ARVEyoutube.has(t) ? await window.ARVEyoutube.get(t).pause() : window.ARVEvimeo.has(t) ? window.ARVEvimeo.get(t).pause() : t.dataset.srcNoAp && (t.src = t.dataset.srcNoAp);
            const n = st(t);
            n && n.classList.remove("arve--playing")
        })
    }

    !function () {
        const e = Ge.createElement("h3");
        document.body.appendChild(e);
        const t = getComputedStyle(e), n = Ge.createElement("style");
        n.id = "arve-pro-title-font-styles", n.textContent = `\n\t\thtml,\n\t\t#html {\n\t\t\t.arve-title,\n\t\t\t.arve-card-title {\n\t\t\t\tfont-family: ${t.fontFamily};\n\t\t\t\tletter-spacing: ${t.letterSpacing};\n\t\t\t\tfont-weight: ${t.fontWeight};\n\t\t\t\tfont-style: ${t.fontStyle};\n\t\t\t\ttext-transform: ${t.textTransform};\n\t\t\t}\n\t\t}`, e.remove(), Ge.head.appendChild(n)
    }(), et(".arve--card .arve-inner").forEach(e => {
        const t = getComputedStyle(e);
        let n = t.gridTemplateColumns.split(" ")[0];
        "0px" === n && (n = t.height), e.style.setProperty("--arve-card-left-col-width", n)
    }), function () {
        if (!window.location.hash) return;
        const e = window.location.hash.replace(/[\s#]+/gi, ""), t = Ke(e), n = Qe('[data-target="#' + e + '"]');
        t && t.matches('.arve[data-mode="lightbox"]') && n && ft(t, n)
    }(), Ge.addEventListener("play", e => {
        e.target instanceof HTMLMediaElement && it(e.target)
    }, !0), Ge.addEventListener("pause", e => {
        e.target instanceof HTMLMediaElement && at(e.target)
    }, !0), Ge.addEventListener("ended", e => {
        e.target instanceof HTMLMediaElement && ct(e.target)
    }, !0), Ge.addEventListener("click", e => {
        if (!(e.target instanceof HTMLDivElement || e.target instanceof HTMLButtonElement || e.target instanceof HTMLAnchorElement)) return;
        const t = e.target.dataset.target;
        if (!t) return;
        const n = Ke(t.replace("#", ""));
        if (!n || !n.matches(".arve") || n.matches(".arve--card.arve--activated") || !(n instanceof HTMLElement)) return;
        const r = n.querySelector(".arve-consent")?.dataset.domain;
        switch (r && (Ge.cookie = `arve-consent-${r}=1; SameSite=strict; max-age=31536000; path=/`, et(`.arve-consent[data-domain="${r}"]`).forEach(e => {
            e.remove()
        })), e.preventDefault(), n.dataset.mode) {
            case"lazyload":
                !async function (e) {
                    et(`.arve:not(#${e.id})`).forEach(e => {
                        e.classList.remove("arve--last-active")
                    }), e.classList.add("arve--last-active");
                    const t = e.querySelector("video");
                    if (e.matches(".arve--card")) {
                        const t = e.querySelector(".arve-inner");
                        if (!t) throw Error("No inner element found");
                        t.removeAttribute("role"), t.removeAttribute("type")
                    }
                    if (await async function (e) {
                        ("grow" in e.dataset || e.matches(".arve--card")) && (e.classList.add("arve--animating"), "grow" in e.dataset && (e.classList.forEach(t => {
                            /align[a-z]+/.test(t) && (e.dataset.alignClass = t, e.classList.remove(t))
                        }), e.classList.add("arve--expanded", "alignfull")), await ut(ot(e)), e.classList.remove("arve--animating"))
                    }(e), e.classList.add("arve--activated"), pt(t), t) t.play(); else {
                        const t = function (e) {
                            const t = e.querySelector(".arve-noscript");
                            if (!t) throw Error(".arve-noscript not found");
                            return function (e) {
                                const t = Ge.createElement("div");
                                t.innerHTML = e.textContent || e.innerHTML;
                                const n = t.querySelector("iframe");
                                if (!n) throw Error("no iframe found");
                                return n
                            }(t)
                        }(e), n = e.querySelector(".arve-embed");
                        if (!n) throw Error(".arve-embed missing");
                        t.classList.add("arve-iframe--loading"), n.appendChild(t);
                        try {
                            await async function (e) {
                                return new Promise((t, n) => {
                                    const r = () => {
                                        e.removeEventListener("load", r), t()
                                    }, o = t => {
                                        e.removeEventListener("error", o), n(new Error(`Iframe failed to load: ${t.message}`))
                                    };
                                    e.addEventListener("load", r), e.addEventListener("error", o)
                                })
                            }(t), t.classList.remove("arve-iframe--loading")
                        } catch (e) {
                            console.error("Error loading iframe:", e)
                        }
                        dt(e, t)
                    }
                    e.classList.add("arve--loaded")
                }(n);
                break;
            case"lightbox":
            case"link-lightbox":
                ft(n, e.target)
        }
    }, !1)
})();